import { Group, Select, Text } from "@mantine/core";
import { useForm } from "@mantine/form";
import { useEffect } from "react";
import Button from "../../components/Button";
import DescriptionField from "../../components/descriptionField";
import InputField from "../../components/inputField";
import ModalWrapper from "../../components/ModalWrapper/ModalWrapper";
import { alphaNumericRegex, descriptionRegex } from "../../constants/index";
import { addAndEditData } from "../generalPostAndEditData";

export const AddIndustry = ({
  opened,
  setOpened,
  allIndustryTypes,
  setUpdate,
  editData,
  setEditData,
  editModalState,
  setEditModalState,
  setLoading,
}) => {
  const industryTypes = allIndustryTypes?.map((industryType) => ({
    label: industryType.typeName,
    value: industryType._id,
  }));
  console.log("hiii", industryTypes);
  const form = useForm({
    validateInputOnChange: true,
    initialValues: {
      industryType: "",
      industryName: "",
      industryDescription: "",
    },

    validate: {
      industryType: (value) =>
        value ? null : "Please select a valid industry type",

      industryName: (value) =>
        value?.trim()?.length > 1 && alphaNumericRegex.test(value.trim())
          ? null
          : "Alphabetic Name with 2 or more characters",
      industryDescription: (value) =>
        value?.trim()?.length > 20 && descriptionRegex.test(value.trim())
          ? null
          : "Description with 20 or more characters",
    },
  });
  useEffect(() => {
    if (editModalState) {
      form.setValues({
        industryType: editData.industryType?._id,
        industryName: editData.industryName,
        industryDescription: editData.industryDescription,
      });
    }
  }, [opened]);

  const onSubmit = (values) => {
    let url = "";
    if (editModalState) {
      values.industryId = editData._id;
      url = "industry/editIndustry";
      setEditData({});
      setEditModalState(false);
    } else {
      url = "industry/addIndustry";
    }
    form.reset();
    setLoading(true);
    addAndEditData(values, setOpened, setUpdate, url);
  };

  const InternalContent = (
    <form onSubmit={form.onSubmit(onSubmit)}>
      <Text mb={0} weight={500}>
        Industry Type
      </Text>
      <Select
        styles={{
          input: {
            padding: "1.2rem",
          },
        }}
        required
        withAsterisk={false}
        placeholder="Select Industry Type"
        data={industryTypes}
        // searchable
        nothingFound="No Industry Type found"
        {...form.getInputProps("industryType")}
      />
      <Text mb={0} weight={500}>
        Industry Name
      </Text>
      <InputField
        width="100%"
        placeholder="Enter Industry Name"
        form={form}
        validateName="industryName"
        style={{ border: "1px solid rgb(0,0,0,0.1)" }}
      />

      <Text mt="md" mb={0} weight={500}>
        Description
      </Text>
      <DescriptionField
        maxRows={4}
        minRows={3}
        autosize={true}
        width="100%"
        placeholder="Enter Type Description"
        form={form}
        validateName="industryDescription"
        style={{ border: "1px solid rgb(0,0,0,0.1)" }}
      />

      <Group position="right" pt="xl">
        <Button
          title={"Clear"}
          fontWeight="700"
          onClick={() => {
            form.reset();
          }}
        />
        <Button
          title={editModalState ? "Edit" : "Add"}
          primary={true}
          fontWeight="700"
          type="submit"
        />
      </Group>
    </form>
  );

  return (
    <ModalWrapper
      opened={opened}
      setOpened={setOpened}
      InternalComponent={InternalContent}
      title={editModalState ? "Edit Industry" : "Add Industry"}
      form={form}
      setEditData={setEditData}
      setEditModalState={setEditModalState}
      addEdit={true}
    />
  );
};
